import TimelineMax from "gsap/TimelineMax"
import TweenMax from "gsap/TweenMax"
import ScrollMagic from "ScrollMagic";
import lottie from "lottie-web";
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'
import "gsap";
import 'animation.gsap';

import letterF from '../lottie/f.json';
import letterL from '../lottie/l.json';
import letterI from '../lottie/i.json';
import letterG from '../lottie/g.json';
import letterH from '../lottie/h.json';
import letterT from '../lottie/t.json';

export default {
    init() {
        let controller = new ScrollMagic.Controller();

        class LetterDrawer {
            constructor(controller) {
                this.controller = controller;

                /**
                 * Set timeout for page to load
                 * and for images to be drawn properly
                 */
                setTimeout(() => {
                    this.init();
                }, 450)
            }

            init() {
                let _this = this;

                $(".flight-letter__outer").each(function () {
                    let $container = $(this);
                    let $svgContainerElem = $(".flight-letter__svg-wrapper", $(this));
                    let animationJson = _this.getLetterJson($svgContainerElem.data('letter'));

                    // get lottie animation json
                    // from import
                    let lottieAnimation = _this.getLottieAnimation($svgContainerElem.get(0), animationJson);

                    // when lottie animation has loaded
                    // link to GSAP and scroll magic
                    lottieAnimation.addEventListener('DOMLoaded', function () {
                        let timeline = new TimelineMax({repeat: 0});

                        // frames are multiplied as lottie animation
                        // was exported with the last 40% as the last frame
                        timeline.to({frame: 0}, 1, {
                            frame: (lottieAnimation.totalFrames / 2) - 1,
                            onUpdate: function () {
                                const progress = this.progress();

                                // stop drawing once complete
                                if (progress < 1) {
                                    lottieAnimation.goToAndStop(this.progress() * (lottieAnimation.totalFrames * 0.54), true)
                                }
                            },
                            Ease: "Linear.easeNone",
                        });

                        /**
                         * Trigger animation from the letter outer container
                         * duration = (height of the browser - nav header height) * modifier value which looks good
                         * scene is triggered 0.05 from the bottom of the page (0 = top, 1 = bottom)
                         */
                        new ScrollMagic.Scene({
                            triggerElement: $container.get(0),
                            duration: (window.innerHeight - $(".header").outerHeight()) * 0.9,
                            triggerHook: 0.95,
                        })
                            .setTween(timeline)
                            .addTo(controller)
                    });
                });

                $('.main-content').addClass('initialised');
            }

            // setup lottie animation object in container
            getLottieAnimation(svgContainer, animationJson) {
                let animData = {
                    container: svgContainer,
                    animationData: animationJson,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                };

                return lottie.loadAnimation(animData);
            }

            // get corresponding lottie animation
            // JSON by letter
            getLetterJson(letter) {
                if (!letter) {
                    return false;
                }

                let json = false;

                switch (letter.toLowerCase()) {
                    case 'f':
                        json = letterF;
                        break;
                    case 'l':
                        json = letterL;
                        break;
                    case 'i':
                        json = letterI;
                        break;
                    case 'g':
                        json = letterG;
                        break;
                    case 'h':
                        json = letterH;
                        break
                    case 't':
                        json = letterT;
                        break;
                    default:
                        json = false;
                }

                return json;
            }
        }

        new LetterDrawer();

        /**
         * Initialise parallax on divs
         */
        $(".flight-letter__outer").each(function () {
            const $trigger = $(this);
            let image = $(".flight-letter__icon", $(this));
            let content = $(".flight-letter__content", $(this));

            if (image) {
                let tween = new TimelineMax()
                    .add([
                        TweenMax.fromTo(image, 1, {scale: 1.2, y: 70}, {y: -10, ease: "sine.inOut"}),
                    ])

                new ScrollMagic.Scene({
                    triggerElement: $trigger.get(0),
                    duration: ($trigger.outerHeight()),
                })
                    .setTween(tween)
                    // .addIndicators()
                    .addTo(controller);
            }

            if (content) {
                let tween = new TimelineMax()
                    .add([
                        TweenMax.fromTo(content, 1, {y: 120}, {y: 0, ease: "sine.inOut"}),
                    ])

                new ScrollMagic.Scene({
                    triggerElement: $trigger.get(0),
                    duration: ($trigger.outerHeight()),
                })
                    .setTween(tween)
                    // .addIndicators()
                    .addTo(controller);
            }
        })

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/inOurDna.js